import { notNull } from "../../../../vendor/plugins/clxMobileNetPortable/assets/responsive/js/common/assert";

export function confirmation() {
    const confirmationButtons = document.querySelectorAll(".confirmation");
    if (confirmationButtons.length > 0) {
        confirmationButtons.forEach((confirmationButton) => {
            // @ts-ignore
            const msg = confirmationButton.dataset.confirmMsg;
            // @ts-ignore
            confirmationButton.addEventListener(
                "click",
                async (e: MouseEvent) => {
                    if (!confirm(msg)) {
                        e.preventDefault();
                    }
                },
            );
        });
    }
    const checkoutNovalButton = document.querySelector(
        "#checkout-noval-button",
    );
    if (checkoutNovalButton) {
        checkoutNovalButton.addEventListener("click", () => {
            const form_action = notNull(
                document.getElementById("form_action"),
            ) as HTMLFormElement;
            form_action.value = "back";
        });
    }
    const checkoutButtonPreview = document.querySelector(
        "#checkout-button-preview",
    );
    if (checkoutButtonPreview) {
        checkoutButtonPreview.addEventListener("click", () => {
            const form_action = notNull(
                document.getElementById("form_action"),
            ) as HTMLFormElement;
            form_action.value = "preview";
        });
    }
}
